import { useContractForCreateExpenseQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useStore } from "../store";

export const useFetchContract = () => {
  const store = useStore();

  const { loading, refetch } = useContractForCreateExpenseQuery({
    variables: { id: store.form.contract_id.value },
    skip: !store.form.contract_id.value,
    notifyOnNetworkStatusChange: true,
    onCompleted({ contract }) {
      if (contract) {
        store.setContract(contract);
      }
    },
    ...onError(),
  });

  store.refetchContract = refetch;
  store.setContractLoading(loading);
};
